import { Component, Input, HostBinding } from "@angular/core";

@Component({
  selector: "med-svg-wrapper",
  template: "",
})
export class SvgMixinComponent {
  @HostBinding("style.display") display = "flex";
  @HostBinding("style.line-height") lineHeight = "inherit";

  protected _size = "24";

  get size(): string {
    return this._size;
  }

  @Input() set size(value: string) {
    this._size = value;
    this.lineHeight = `${value}px`;
  }
}
